import type { OnboardingCaseType, WizardCaseInfo } from "../types";

export const resolveProfileEntityName = (
  existingName: string | undefined,
  caseType: OnboardingCaseType,
  caseInfo: Pick<WizardCaseInfo, "clientName" | "entityName"> | null,
): string => {
  if (existingName?.trim()) return existingName;
  const fromCaseInfo = caseType === "client" ? caseInfo?.clientName : caseInfo?.entityName;
  return fromCaseInfo?.trim() ?? "";
};
